import { Media } from 'generated/graphql';

export function toImgSrc(media?: Media) {
  if (!media) return null;
  if (media?.videoThumbnailUrl) return media.videoThumbnailUrl;
  if (!media.image) return null;
  if (!media.cdn01) return media.image;

  return encodeURI(media.cdn01 + media.image);
}

export function toImgSrcRaw(media?: Media) {
  if (!media) return null;
  if (media?.videoThumbnailUrl) return media.videoThumbnailUrl;
  if (!media.image) return null;
  if (!media.cdn01) return media.image;

  return media.cdn01 + media.image;
}

export function toVideoSrc(media?: Media) {
  if (!media) return null;
  if (media?.videoUrl) return media.videoUrl;
  if (!media.video) return null;
  if (!media.cdn01) return media.video;

  return encodeURI(media.cdn01 + media.video);
}
